<section class="titulo">
    <p>
        <br><br>
    </p>
    <div class="titleImagen">
        <p style="line-height: 100%;" class="fontMS700 font-45 colorPrincipal">
            COMUNIDADES CANTADAS <br>
            <span class="fontMS300">
                LAS COMPOSICIONES <br> DE HIMNOS<br>
            </span>
        </p>
        <div id="sharePic">
            <a (click)="test.toggle()" mdbWavesEffect>
                <img width="200px" src="/assets/images/general/MP_BOTON_COMPARTIR.jpg">
            </a>
            <div mdbCollapse #test="bs-collapse">
                <div class="divShared">
                    &nbsp;
                    &nbsp;
                    <a target="_blank"
                        href="http://www.facebook.com/sharer.php?u=https://memoriaperu.bnp.gob.pe%2F%23%2Fmicrositio7/himnos">
                        <img width="25px" src="/assets/images/general/MP_BOTON_COMPARTIR_FB.png">
                    </a>&nbsp;
                    <a target="_blank"
                        href="https://api.whatsapp.com/send?text=https://memoriaperu.bnp.gob.pe%2F%23%2Fmicrositio7/himnos">
                        <img width="25px" src="/assets/images/general/MP_BOTON_COMPARTIR_INST.png">
                    </a>&nbsp;
                    <a target="_blank"
                        href="https://twitter.com/intent/tweet?text=MemoriaPeru&url=https://memoriaperu.bnp.gob.pe%2F%23%2Fmicrositio7/himnos">
                        <img width="25px" src="/assets/images/general/MP_BOTON_COMPARTIR_TW.png">
                    </a>
                </div>
            </div>
        </div>
    </div>
    <img width="100%" src="/assets/images/micrositio/micrositio7/ET03_MS09_HIM_img001.jpg">
</section>
<div class="fondoBlanco_Intro">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <p class="fontMS500 text-justify font-24">
                    <br>
                    LA MÚSICA Y EL CANTO SON PODEROSOS Y EFICACES INSTRUMENTOS PARA LA CONSTRUCCIÓN SOCIAL DE
                    DETERMINADAS IDEAS Y VALORES. EN EL CASO DE LOS HIMNOS SE RECONOCE UNA INTERACCIÓN ENTRE EL HECHO
                    MUSICAL Y UNA EXPERIENCIA COLECTIVA E INTEGRADORA, DONDE EL INDIVIDUO PASA A IDENTIFICARSE MIEMBRO
                    DE UNA COMUNIDAD, UN GRUPO, UN COLECTIVO Y EN CASOS, COMO LOS HIMNOS PATRIÓTICOS SE GENERAN, ADEMÁS,
                    VÍNCULOS EMOCIONALES. LA COMPOSICIÓN MUSICAL Y CORAL DE LOS HIMNOS ESTÁ DIRECTAMENTE LIGADA A
                    MOMENTOS SOCIALES E HISTÓRICOS DETERMINADOS Y AL ANALIZAR SUS ELEMENTOS SE DESCUBREN RELACIONES
                    IDEOLÓGICAS, ADEMÁS DE VALORES SIMBÓLICOS Y ESTÉTICOS.
                    <br>
                </p>
                <p class="fontMS100 text-justify font-23">
                    <br>
                    Las partituras seleccionadas corresponden a la colección Rodolfo Holzmann que forma parte de la
                    colección de música manuscrita de la Biblioteca Nacional del Perú. La relevancia de estos archivos
                    se encuentra en la documentación de cómo se establece la representación de ciertos valores
                    culturales sobre patria o pertenencia regional, educación, trabajo, fe cristiana o el rol de
                    subordinación femenino.
                    <br><br>
                    El musicólogo y compositor Holzmann (1910-1992) además de su labor docente en el Conservatorio
                    Nacional de Música (1945), se desempeñó como su jefe de biblioteca, discoteca y archivo. El escritor
                    José María Arguedas, director del Museo Nacional de Historia, lo nombró como jefe del servicio
                    musicológico de la Escuela Nacional de Música y Danzas Folklóricas (1957). Producto de sus
                    investigaciones sobre música peruana académica y tradicional, reunió un extenso archivo recopilado
                    sobre música impresa desde fines del siglo XIX.
                    <br>
                </p>
            </div>
        </div>
    </div>
</div>
<div class="fondoGrisBg1">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-3">
                        <img class="LineSubsec2" width="100%"
                            src="\assets\images\micrositio\micrositio7\ET03_MS09_HIM__LINEA1-recortada3.png">
                    </div>
                    <div class="col-sm-6">
                        <p style="line-height: 100%;margin-bottom: 0%;"
                            class="fontMS500 text-center colorPrincipal font-38">
                            LAS MÚLTIPLES VERSIONES
                        </p>
                    </div>
                    <div class="col-sm-3">
                        <img class="LineSubsec2 bottom_cel" width="100%"
                            src="\assets\images\micrositio\micrositio7\ET03_MS09_HIM__LINEA1-recortada3.png">
                    </div>
                </div>
            </div>
            <p style="line-height: 100%;margin-top: 0%;margin-bottom: 0%;"
                class="fontMS700 text-center colorPrincipal font-38">
                DEL HIMNO NACIONAL DEL PERÚ
            </p>
            <div class="c100">
                <img class="LineSubsec2 lineCel" width="100%"
                    src="\assets\images\micrositio\micrositio7\ET03_MS09_HIM__LINEA1-recortada3.png">
            </div>
            <div class="col-sm-12">
                <p class="font-24 text-center fontMS500">
                    <br><br>
                    LAS PARTITURAS SELECCIONADAS SEÑALAN EL LARGO TRÁNSITO POR ESTABLECER DEFINITIVAMENTE LA MÚSICA Y
                    LETRA DEL HIMNO NACIONAL DE MANERA OFICIAL. COMPUESTAS POR JOSÉ BERNARDO ALZEDO RETUERTO Y JOSÉ DE
                    LA TORRE UGARTE Y ALARCÓN MANRIQUE EN 1821, NO SE CUENTA CON LAS PARTITURAS ORIGINALES Y LAS
                    SUCESIVAS SE DIFERENCIAN POR EL TIEMPO MUSICAL, EL CARÁCTER Y LA SUSTITUCIÓN O REINCORPORACIÓN DE
                    LAS ESTROFAS ORIGINALES.
                    <br>
                </p>
            </div>
            <div class="col-sm-12">
                <p class="font-24 text-justify fontMS100">
                    <br>
                    La versión de 1863 del músico sueco Carlos Juan Eklund, que incorpora la estrofa apócrifa <span
                        class="fontMS100Italic"> Largo tiempo</span>, originó en 1864 que el propio Alzedo presentara su
                    versión oficial, contra las diversas versiones que circulaban en ese momento. En 1869 el compositor
                    italiano Claudio Rebagliati realiza una restauración que agrega cuerdas, trompetas y trombones,
                    versión que contó con la aprobación de un anciano Alzedo. Ésta es oficializada todavía hasta 1901,
                    cuando una comisión nombrada por el Ministerio de Gobierno emite una Resolución Suprema firmada por
                    el presidente Eduardo López de Romaña donde aprueba las modificaciones de Rebagliati. En 1913 el
                    gobierno de Guillermo Billinghurst declara la intangibilidad del Himno Nacional por ley, aunque se
                    inserta como primera estrofa "Largo tiempo…". Para las olimpiadas de Berlín de 1936, el compositor
                    alemán Leopold Weninger realizó arreglo orquestal del himno que se sigue ejecutando.
                    <br><br>Para 1950, una Resolución Suprema con firma del presidente Manuel Odría declara consignar a
                    Claudio Rebagliati como restaurador oficial del himno en cualquier edición impresa o grabada.
                    Paralelamente, ante la falta de una versión que incorporara a una amplia población multicultural, el
                    profesor Eustaquio Rodríguez realiza una traducción de la letra en quechua y aymara.
                    <br>
                </p>
            </div>
        </div>
    </div>
    <div class="w-90 text-center mt-5 ml-auto mr-auto">
        <ngx-slick-carousel class="carousel" #slickModal="slick-carousel" [config]="slideConfig">
            <div ngxSlickItem *ngFor="let slide of slides" class="slide p-2">
                <a href="{{slide.id}}" style="color: inherit;" target="_blank">
                    <div class="divLibros text-center w-100">
                        <p class="text-center">
                            <img src="{{ slide.img }}" alt="" width="100%">
                        </p>
                        <div class="divNombresLibros mb-3">
                            <p class="text-center">
                                <span class="fontMS500">{{slide.autor}}</span><br>
                                <span>{{slide.titulo}}</span><br>
                                <span>{{slide.ano}}</span>
                            </p>
                        </div>
                    </div>
                </a>
            </div>
        </ngx-slick-carousel>
    </div>

</div>
<div class="fondoGris2">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <img src="/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_LINEA_RESALTE.png" width="100%">
                <p class="text-justify fontMS500 text-upper font-24">
                    <br>
                    <span>
                        ...para establecer realmente la importancia del trabajo de Claudio Rebagliati hay que tomar en
                        cuenta que, luego de haber vivido ya dos años [en Lima] -estamos hablando de aproximadamente
                        1865- se le ocurre, acorde con los movimientos musicales de otros países, recoger las melodías
                        que se escuchaban en las calles y plazas, y presentarlas en una obra. Compone así “Un 28 de
                        Julio”, también llamada Rapsodia Peruana. Su estreno en 1868 fue un gran éxito y una verdadera
                        carta de presentación por la cual Claudio adquiere quizá el suficiente prestigio para que Alzedo
                        lo considerara capaz de emprender la “restauración” del Himno Nacional
                    </span>
                </p>
                <p class="text-right fontMS300Italic text-upper font-24">
                    <span>
                        Augusto Rebagliati, 2018.
                    </span>
                    <br>
                </p>
                <img src="/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_LINEA_RESALTE.png" class="reflejo"
                    width="100%">
            </div>
        </div>
    </div>
</div>
<div class="fondoBg2">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-3">
                        <img class="LineSubsec2 " width="100%"
                            src="\assets\images\micrositio\micrositio7\ET03_MS09_HIM__LINEA1-recortada3.png">
                    </div>
                    <div class="col-sm-6">
                        <p style="line-height: 100%;margin-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal font-40">
                            LA PATRIA NUEVA Y LEGUÍA
                        </p>
                    </div>
                    <div class="col-sm-3">
                        <img class="LineSubsec2" width="100%"
                            src="\assets\images\micrositio\micrositio7\ET03_MS09_HIM__LINEA1-recortada3.png">
                    </div>
                </div>
                <p class="font-24 fontMS500 font text-center">
                    <br>
                    AUGUSTO B. LEGUÍA (1863-1932) FUE DECLARADO PRESIDENTE DE LA REPÚBLICA POR UNA ASAMBLEA NACIONAL
                    LUEGO DE LOS COMICIOS DE 1919. SU POSTURA POLÍTICA CAPITALIZÓ EL DESCONTENTO DE LA POBLACIÓN POR EL
                    MODELO ECONÓMICO DE LA “REPÚBLICA ARISTOCRÁTICA” QUE GOBERNÓ EL PERÚ ENTRE 1899 Y 1919.
                    <br>
                </p>
                <p class="font-24 text-gris text-justify">
                    <br>
                    La idea de romper con el círculo aristocrático de políticos formados en el siglo XIX que habían
                    gobernado al país e incorporar a la clase media urbana, y en menor grado a la clase obrera e
                    indígenas en la modernización del país, fue la base para construir el concepto de “Patria Nueva”.
                    Aunque, más que un programa concreto o una ideología racionalizada, se tradujo en un discurso
                    simbólico y en algunos casos demagógico de progreso social.
                    <br><br>
                </p>
                <div class="row">
                    <div class="col-sm-4 libro">
                        <a href="http://hdl.handle.net/20.500.14428/79082" style="color: inherit;" target="_blank">
                            <img src="/assets/images/micrositio/micrositio7/ET03_MS09_HIM_img014.jpg"
                                class="img-fluid mb-3" width="100%">
                            <div class="overlay">
                                <p class="fontMS500">
                                    El canto nuevo. Himno plebiscitario
                                    <br>
                                    <span class="fontMS100">Música de Federico Gerdes y letra de R. Pérez
                                        Reinoso,
                                        <br>
                                        Ca. 1922
                                    </span>
                                </p>
                            </div>
                        </a>
                    </div>
                    <div class="col-sm-4 libro">
                        <a href="https://hdl.handle.net/20.500.14428/65651" style="color: inherit;" target="_blank">
                            <img src="/assets/images/micrositio/micrositio7/ET03_MS09_HIM_img015.jpg"
                                class="img-fluid mb-3" width="100%">
                            <div class="overlay">
                                <p class="fontMS500">
                                    Patria Nueva
                                    <br>
                                    <span class="fontMS100">
                                        Himno triunfal para piano. Música de César A. Ciociano,
                                        <br>Ca. 1930
                                    </span>
                                </p>
                            </div>
                        </a>
                    </div>
                    <div class="col-sm-4 libro">
                        <a href="https://hdl.handle.net/20.500.14428/65657" style="color: inherit;" target="_blank">
                            <img src="/assets/images/micrositio/micrositio7/ET03_MS09_HIM_img016.jpg"
                                class="img-fluid mb-3" width="100%">
                            <div class="overlay">
                                <p class="fontMS500">
                                    Leguía (himno)
                                    <br>
                                    <span class="fontMS100">
                                        Letras del Dr. Arturo Montoya y música del Presbítero Dr. Pablo Chávez Aguilar,
                                        <br>
                                        Ca. 1930
                                    </span>
                                </p>
                            </div>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="fondoGris">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <p class="font-24 text-justify fontMS100">
                    <span class="font-weight-bold">Pablo Chávez Aguilar</span> (Lima, 1898-1950) Compositor, organista,
                    director de coros y maestro. Realizó sus primeros estudios musicales en el Seminario de Santo
                    Toribio de Lima. Completó su formación musical en la Escuela Pontificia de Música Sacra en Italia.
                    Al regresar a Lima, a fines de 1924, el Cabildo de Lima lo nombró maestro de capilla de la basílica
                    metropolitana, cargo que conservó hasta 1938, para reasumirlo cuatro años más tarde, y desde
                    entonces lo desempeñó hasta su fallecimiento en 1950. La colección Rodolfo Holzmann de la Biblioteca
                    Nacional del Perú cuenta con una treintena de partituras impresas de Chávez Aguilar entre himnos y
                    canciones religiosas (letanías, <span class="fontMS100Italic">tantum ergo</span>, cantatas),
                    villancicos, preludios y canciones escolares. El crítico Carlos Raygada consideró que su producción
                    era de primer nivel por su dominio técnico y la vastedad de su obra.
                </p>
            </div>
        </div>
    </div>
</div>
<div class="fondoMarron">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-5">
                        <p style="line-height: 220%;margin-bottom: 0%;" class="fontMS700 colorPrincipal font-38">
                            HIMNOS RELIGIOSOS
                        </p>
                    </div>
                    <div class="col-sm-7 c100">
                        <img class="LineSubsec_Izq" width="100%"
                            src="\assets\images\micrositio\micrositio7\ET03_MS09_HIM__LINEA1-recortada.png">
                    </div>
                </div>
                <p class="font-24 text-justify fontMS500 text-white mt-4">
                    <br>
                    LOS HIMNOS RELIGIOSOS SE PUEDEN DEFINIR COMO CANTOS DE ALABANZA DIRIGIDOS A LA DIVINIDAD CON UN
                    CARÁCTER DOCTRINAL.
                    <br>
                </p>
                <p class="font-24 fontMS300 text-justify text-white">
                    <br>
                    La participación de los devotos en esta experiencia musical, en el marco de misas y otras formas de
                    recogimiento espiritual, incentiva un sentimiento de cercanía e interacción con lo divino.
                    Históricamente en nuestro país, los himnos religiosos tuvieron gran relevancia para el
                    adoctrinamiento cristiano en las parroquias indígenas inmediatamente después de establecida la
                    conquista. Tempranamente, el Concilio provincial de Lima de 1551 integró las lenguas nativas en el
                    culto católico, cantándose en quechua y aymara los himnos de origen europeo.
                    <br>
                </p>
            </div>
        </div>
    </div>
    <div class="container">
        <div class="row">
            <div class="col-sm-3 libro">
                <a href="http://hdl.handle.net/20.500.14428/79106" style="color: inherit;">
                    <img src="/assets/images/micrositio/micrositio7/ET03_MS09_HIM_img017.jpg" class="img-fluid mb-3"
                        width="100%">
                    <div class="overlay">
                        <p class="fontMS500">
                            Himno al beato Martín de Porres: en el primer centenario de su Beatificación
                            (1837-1937)<br>
                            <span class="fontMS100">
                                Letra y música de José Jaime Aicua,
                                <br>
                                Ca. 1940<br>
                            </span>
                        </p>
                    </div>
                </a>
            </div>
            <div class="col-sm-3 libro">
                <a href="https://hdl.handle.net/20.500.14428/65660" style="color: inherit;">
                    <img src="/assets/images/micrositio/micrositio7/ET03_MS09_HIM_img018.jpg" class="img-fluid mb-3"
                        width="100%">
                    <div class="overlay">
                        <p class="fontMS500">
                            Himno a Santa Rosa de Lima: patrona del Primer Congreso Eucarístico Nacional<br>
                            <span class="fontMS100">
                                Música de Pablo Chávez Aguilar, maestro de Capilla de la Basílica Metropolitana
                                de
                                Lima,<br> 1935<br>
                            </span>
                        </p>
                    </div>
                </a>
            </div>
            <div class="col-sm-3 libro">
                <a href="http://hdl.handle.net/20.500.14428/79093" style="color: inherit;">
                    <img src="/assets/images/micrositio/micrositio7/ET03_MS09_HIM_img019.jpg" class="img-fluid mb-3"
                        width="100%">
                    <div class="overlay">
                        <p class="fontMS500">
                            ¡Oh Dios Eucaristía! Himno oficial de los Congresos Eucarísticos del Perú
                            <br>
                            <span class="fontMS100">
                                Música de Pablo Chávez Aguilar; letra de Francisco Jambrina,
                                <br>
                                1949<br>
                            </span>
                        </p>
                    </div>
                </a>
            </div>
            <div class="col-sm-3 libro">
                <a href="http://hdl.handle.net/20.500.14428/79091" style="color: inherit;">
                    <img src="/assets/images/micrositio/micrositio7/ET03_MS09_HIM_img020.jpg" class="img-fluid mb-3"
                        width="100%">
                    <div class="overlay">
                        <p class="fontMS500">
                            Himno oficial del Primer Congreso Nacional de Terciarios Franciscanos<br>
                            <span class="fontMS100">
                                Música de Pacífico Chirinos; letra del señor José A. Pacheco Andía,
                                <br>1945<br>
                            </span>
                        </p>
                    </div>
                </a>
            </div>
        </div>
    </div>
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12 mt-5">
                <p>
                    <img width="100%" src="/assets/images/micrositio/micrositio6/E03-MS08-GRAMA_LINEA2.jpg">
                </p>
            </div>
        </div>
    </div>
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-5">
                        <p style="line-height: 220%;margin-bottom: 0%;" class="fontMS700 colorPrincipal font-38">
                            HIMNOS REGIONALES
                        </p>
                    </div>
                    <div class="col-sm-7 c100">
                        <img class="LineSubsec_Izq" width="100%"
                            src="\assets\images\micrositio\micrositio7\ET03_MS09_HIM__LINEA1-recortada.png">
                    </div>
                </div>
                <p class="font-24 text-justify fontMS300 text-white">
                    <br>
                    Un distintivo de los himnos es conseguir la identificación del individuo hacia un colectivo
                    determinado a escala comunitaria, regional o nacional. La conmemoración de efemérides históricas y
                    políticas ponen en contexto discursos sobre el sentido de pertenencia.
                    <br>
                </p>
            </div>
        </div>
    </div>
    <div class="container">
        <div class="row">
            <div class="col-sm-3 libro">
                <a href="http://hdl.handle.net/20.500.14428/79092" style="color: inherit;">
                    <img src="/assets/images/micrositio/micrositio7/ET03_MS09_HIM_img020a.jpg" class="img-fluid mb-3"
                        width="100%">
                    <div class="overlay">
                        <p class="fontMS500">
                            Himno a Tacna para piano y canto<br>
                            <span class="fontMS100">
                                Música de Alberto Díaz Robles, letra de Víctor Ballón Angulo,
                                <br>Ca. 1938
                                <br>
                            </span>
                        </p>
                    </div>
                </a>
            </div>
            <div class="col-sm-3 libro">
                <a href="http://hdl.handle.net/20.500.14428/79105" target="_blank" style="color: inherit;">

                    <img src="/assets/images/micrositio/micrositio7/ET03_MS09_HIM_img021.jpg" class="img-fluid mb-3"
                        width="100%">
                    <div class="overlay">
                        <p class="fontMS500">
                            El oriente peruano (himno) Homenaje a los departamentos de Loreto, Amazonas, San Martín,
                            Madre
                            de Dios y Huánuco <br>
                            <span class="fontMS100">
                                Letra de José M. Zárate, música de Ángel E. Alvarado,<br>
                                Ca. 1930
                                <br>
                            </span>
                        </p>
                    </div>
                </a>
            </div>
            <div class="col-sm-3 libro">
                <a href="http://hdl.handle.net/20.500.14428/79090" style="color: inherit;">
                    <img src="/assets/images/micrositio/micrositio7/ET03_MS09_HIM_img022.jpg" class="img-fluid mb-3"
                        width="100%">
                    <div class="overlay">
                        <p class="fontMS500">
                            Himno del Amazonas. Letra del Comité Amazónico<br>
                            <span class="fontMS100">
                                Música de Anita Edery Maldonado,<br>
                                1942
                                <br>
                            </span>
                        </p>
                    </div>
                </a>
            </div>
            <div class="col-sm-3 libro">
                <a href="http://hdl.handle.net/20.500.14428/79085" style="color: inherit;">
                    <img src="/assets/images/micrositio/micrositio7/ET03_MS09_HIM_img023a.jpg" class="img-fluid mb-3"
                        width="100%">
                    <div class="overlay">
                        <p class="fontMS500">
                            Himno Centenario Callao. Homenaje al Callao en su primer Centenario Político <br>
                            <span class="fontMS100">
                                Música y letra de la maestra Rosalía Miranda Fernández,<br>
                                Ca. 1936
                            </span>
                        </p>
                    </div>
                </a>
            </div>
        </div>
    </div>
    <div class="container">
        <div class="row">
            <div class="col-sm-12 mt-5">
                <p>
                    <br>
                    <img width="100%" src="/assets/images/micrositio/micrositio6/E03-MS08-GRAMA_LINEA2.jpg">
                    <br>
                </p>
            </div>
        </div>
    </div>
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-5">
                        <p style="line-height: 220%;margin-bottom: 0%;" class="fontMS700 colorPrincipal font-38">
                            HIMNOS ESCOLARES
                        </p>
                    </div>
                    <div class="col-sm-7 c100">
                        <img class="LineSubsec_Izq" width="100%"
                            src="\assets\images\micrositio\micrositio7\ET03_MS09_HIM__LINEA1-recortada.png">
                    </div>
                </div>
                <p class="font-24 text-justify fontMS300 text-white">
                    <br>
                    Al inicio del siglo XX la educación era parte central del proceso de modernización nacional
                    emprendida desde el Estado y a través de ésta el fortalecimiento de valores cívicos, patrióticos y
                    de moral cristiana. Entre las décadas de 1930 y 1940 se da un crecimiento de las clases medias y la
                    enseñanza primaria y, sobretodo, la secundaria tienen una expansión considerable, por lo que el
                    Estado amplía su capacidad formativa. Los himnos escolares despiertan el sentido de singularidad y
                    pertenencia de los estudiantes hacia su entidad educativa. En sus composiciones se resaltan los
                    valores con los que se crea la institución y la importancia de sus miembros, dejando en claro su
                    misión, sus objetivos y logros. Son también herramientas de disciplina y moral, y nos dan luces
                    sobre el tipo de ciudadano que se pretendía formar.
                </p>
            </div>
        </div>
    </div>
    <div class="w-90 text-center mt-5 ml-auto mr-auto">
        <ngx-slick-carousel class="carousel" #slickModal="slick-carousel" [config]="slideConfig">
            <div ngxSlickItem *ngFor="let slide of slides2" class="slide p-1">
                <div class="libro">
                    <a href="{{slide.id}}" target="_blank" style="color: inherit;">
                        <img src="{{ slide.img  }}" class="img-fluid" width="100%">
                        <div class="overlay2">
                            <p class="text-center">
                                <span class="fontMS500">{{slide.descripcion}}</span><br>
                                {{slide.subtexto}}<br>
                                <span>{{slide.ano}}</span>
                            </p>
                        </div>
                    </a>
                </div>
            </div>
        </ngx-slick-carousel>
    </div>
</div>

<div class="fondoBg3">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-3">
                        <img class="LineSubsec2" width="100%"
                            src="\assets\images\micrositio\micrositio7\ET03_MS09_HIM__LINEA1-recortada3.png">
                    </div>
                    <div class="col-sm-6">
                        <p style="line-height: 130%;margin-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal font-37">
                            LOS HIMNOS DEL FEMINISMO
                        </p>
                    </div>
                    <div class="col-sm-3">
                        <img class="LineSubsec2 bottom_cel" width="100%"
                            src="\assets\images\micrositio\micrositio7\ET03_MS09_HIM__LINEA1-recortada3.png">
                    </div>
                </div>
                <p style="line-height: 100%;margin-top: 0%;" class="fontMS500 text-center colorPrincipal font-37">
                    Y DE LA MUJER AMERICANA
                </p>
                <div class="c100">
                    <img class="lineCel" width="100%"
                        src="\assets\images\micrositio\micrositio7\ET03_MS09_HIM__LINEA1-recortada3.png">
                </div>
            </div>
            <div class="col-sm-12">
                <p class="font-24 fontMS500 font text-center">
                    <br>
                    LAS MUJERES ILUSTRADAS DE FINALES DEL SIGLO XIX CENTRARON SU LUCHA EN EL DERECHO A LA EDUCACIÓN,
                    INSISTIENDO EN LA OBLIGATORIEDAD, LAICIDAD Y GRATUIDAD DE LA ENSEÑANZA PRIMARIA. SOBRESALEN TERESA
                    GONZÁLEZ DE FANNING, ELVIRA GARCÍA Y GARCÍA, TRINIDAD ENRÍQUEZ Y LADRÓN DE GUEVARA, JUANA ALARCO DE
                    DAMMERT, ENTRE OTRAS.
                    <br>
                </p>
                <p class="font-24 text-gris text-justify">
                    <br>
                    En 1911, María Jesús Alvarado expone el Primer Programa Feminista de la Mujer Peruana y en 1914
                    funda en Lima el primer grupo “Evolución Feminista”, apelando al sufragio de la mujer y cuestionando
                    el contenido del Código Civil referido al derecho al matrimonio y la familia, donde la mujer estaba
                    sujeta a las tutelas del padre y del marido. En 1924, Zoila Aurora Cáceres funda la agrupación
                    “Feminismo Peruano”, estableciendo entre sus fines la dación de leyes que establezcan la igualdad
                    del hombre y la mujer en el terreno del derecho, especialmente para que se le otorgue la facultad de
                    votar.
                    <br>
                </p>
                <p class="font-24 text-gris text-justify">
                    <br>
                    Sin embargo, paralelamente a la lucha por el reconocimiento igualitario, se continuaba asumiendo de
                    la mujer un rol de crianza, protección y moral, como se aprecia en las letras de los himnos
                    seleccionados, a pesar de las diferencias de contexto en las actividades de corte político,
                    religioso y científico.
                    <br>
                </p>
            </div>
        </div>
    </div>
    <div class="container-big">
        <div class="row p-3">
            <div class="col-sm-3 libro">
                <a href="http://hdl.handle.net/20.500.14428/79103" style="color: inherit;">
                    <img src="/assets/images/micrositio/micrositio7/ET03_MS09_HIM_img027.jpg" class="img-fluid mb-3"
                        width="100%">
                    <div class="overlay">
                        <p class="fontMS500">
                            Himno Segunda Conferencia Pan Americana de Mujeres <br>
                            <span class="fontMS100">
                                Letra de Amalia Puga de Losada, música de Rosa Mercedes Ayarza de Morales del Solar,
                                <br>
                                Ca. 1924
                                <br>
                            </span>
                        </p>
                    </div>
                </a>
            </div>
            <div class="col-sm-3 libro">
                <a href="http://hdl.handle.net/20.500.14428/79102" target="_blank" style="color: black;">
                    <img src="/assets/images/micrositio/micrositio7/ET03_MS09_HIM_img028.jpg" class="img-fluid mb-3"
                        width="100%">
                    <div class="overlay">
                        <p class="fontMS500">
                            Himno a la mujer de todas las Américas <br>
                            <span class="fontMS100">
                                Letra de Catalina Recavarren de Zizold, música de Victoria Vargas de Sivirichi,
                                <br>Ca. 1940
                                <br>
                            </span>
                        </p>
                    </div>
                </a>
            </div>
            <div class="col-sm-3 libro">
                <a href="http://hdl.handle.net/20.500.14428/79094" target="_blank" style="color: black;">
                    <img src="/assets/images/micrositio/micrositio7/ET03_MS09_HIM_img029.jpg" class="img-fluid mb-3"
                        width="100%">
                    <div class="overlay">
                        <p class="fontMS500">
                            Himno de la juventud femenina de la Acción Católica Peruana <br>
                            <span class="fontMS100">
                                Música de P. Chávez Aguilar, letra de Esther Allison,<br> Ca. 1935
                                <br>
                            </span>
                        </p>
                    </div>
                </a>
            </div>
            <div class="col-sm-3 libro">
                <a href="https://hdl.handle.net/20.500.14428/65654" target="_blank" style="color: black;">
                    <img src="/assets/images/micrositio/micrositio7/ET03_MS09_HIM_img030.jpg" class="img-fluid mb-3"
                        width="100%">
                    <div class="overlay">
                        <p class="fontMS500">
                            Himno de la Escuela Nacional de Enfermeras "Hospital Arzobispo Loayza"<br>
                            <span class="fontMS100">
                                Música de Pablo Chávez Aguilar,<br>
                                1928
                                <br>
                            </span>
                        </p>
                    </div>
                </a>
            </div>
        </div>
    </div>
</div>

<div class="fondoOrange">
    <div class="container">
        <div class="row p-5">
            <div class="col-sm-12">
                <div style="margin-bottom: 5%;" class="row">
                    <div class="col-sm-4">
                        <p style="line-height: 100%;margin-bottom: 0%;" class="fontMS500 text-white font-70">
                            Espacio <br> de diálogo
                        </p>
                    </div>
                    <div class="col-sm-8">
                        <img id="img_dialogo"
                            src="\assets\images\micrositio\micrositio1\ET01_MS01_FEDE_LINEA_DIALOGO1.png">
                    </div>
                </div>
                <div class="row">
                    <!-- <div class="col-sm-4">
                        <img class="img-fluid mb-3 pointer" width="100%"
                            src="\assets\images\micrositio\micrositio1\ET01_MS01_FEDE_img008c.jpg">
                    </div> -->
                    <div class="col-sm-12">
                        <p class="text-white fontMS500 font-24">
                            Los valores culturales se refieren al conjunto de creencias, costumbres, tradiciones y
                            relaciones entre los miembros de una comunidad o sociedad. A través del material aquí
                            recopilado podemos evaluar si esos valores culturales, promocionados en himnos de
                            instituciones políticas, educativas o religiosas, siguen siendo válidos hoy en día.
                        </p>
                    </div>
                    <div class="col-sm-12 mb-5 mt-4">
                    </div>
                    <div class="col-sm-4">
                        <p class="text-white fontMS500 font-24">
                            ¿Cuáles himnos debería promocionarse y cuáles no?
                        </p>
                        <img class="img_dialogoCol" src="\assets\images\general\DIALOGO_470.png">
                    </div>
                    <div class="col-sm-4">
                        <p class="text-white fontMS500 font-24">
                            ¿Continúan en vigencia los valores “femeninos” que se encuentran en los himnos?
                        </p>
                        <img class="img_dialogoCol" src="\assets\images\general\DIALOGO_470.png">
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="fondoBlanco">
    <div class="container">
        <div class="row p-5">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-4">
                        <img class="LineSubsec2" width="100%"
                            src="\assets\images\micrositio\micrositio7\ET03_MS09_HIM__LINEA1-recortada3.png">
                    </div>
                    <div class="col-sm-4">
                        <p style="line-height: 160%;margin-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal font-38">
                            PARA SABER MÁS
                        </p>
                    </div>
                    <div class="col-sm-4">
                        <img class="LineSubsec2" width="100%"
                            src="\assets\images\micrositio\micrositio7\ET03_MS09_HIM__LINEA1-recortada3.png">
                    </div>
                </div>
                <p class="font-24 text-gris">
                    <br>
                    Recomendamos algunas de las fuentes consultadas durante la investigación.
                    <br><br>
                </p>
                <div class="row">
                    <div class="col-sm-6">
                        <p class="font-24">
                            <span class="fontMS500">Alzedo Retuerto, J. B. (2018).</span><br>
                            <span class="fontMS100Italic text-gris">Filosofía elemental de la música.<br></span>
                            <span class="text-gris"> Lima: Universidad Nacional de Música</span> <br>
                            <a href="http://info.bnp.gob.pe:80/cgi-bin/abnopac?TITN=572280" target="_blank"
                                style="color: black;">
                                <span class="fas fa-share-square text-gris"></span>
                            </a>
                        </p>
                        <p class="font-24">
                            <span class="fontMS500">Congreso Nacional de Terciarios Franciscanos (1946)</span><br>
                            <span class="fontMS100Italic text-gris">Crónica del primer Congreso Nacional de
                                Terciarios Franciscanos de 1945<br></span>
                            <span class="text-gris">Lima: Delegación General de la Orden Franciscana en la América
                                Meridional<br></span>
                            <a href="http://info.bnp.gob.pe:80/cgi-bin/abnopac?TITN=272167" target="_blank"
                                style="color: black;">
                                <span class="fas fa-share-square text-gris"></span>
                            </a>
                        </p>
                        <p class="font-24">
                            <span class="fontMS500">Mamani Sánchez, E. (1968).</span><br>
                            <span class="fontMS100Italic text-gris">Himnos y canciones escolares.</span>
                            <br>
                            <span class="text-gris">Lima: Edit. Universitaria</span><br>
                            <a href="http://info.bnp.gob.pe:80/cgi-bin/abnopac?TITN=295563" target="_blank"
                                style="color: black;">
                                <span class="fas fa-share-square text-gris"></span>
                            </a>
                        </p>
                    </div>
                    <div class="col-sm-6">
                        <p class="font-24">
                            <span class="fontMS500">Tissera, A. (2013).</span><br>
                            <span class="fontMS100Italic text-gris">San Martín y Bolívar: los himnos nacionales
                                de Perú.<br></span>
                            <span class="text-gris">
                                Lima: Instituto de Estudios Peruanos<br>
                            </span>
                            <a href="https://www.google.com/url?sa=t&rct=j&q=&esrc=s&source=web&cd=&cad=rja&uact=8&ved=2ahUKEwiR-8rivKztAhX1LLkGHWadBtoQFjAJegQIChAC&url=http%3A%2F%2Frepositorio.iep.org.pe%2Fbitstream%2FIEP%2F970%2F2%2Fdocumentodetrabajo190.pdf&usg=AOvVaw1e3mVwQ1uOsSDLmURgoX9S"
                                target="_blank" style="color: black;">
                                <span class="fas fa-share-square text-gris"></span>
                            </a>
                        </p>
                        <p class="font-24">
                            <span class="fontMS500"> Entrevista a Miguel Oblitas y Augusto Rebagliati (2018).</span><br>
                            <span class="fontMS100Italic text-gris">Un 28 de Julio. Ciento cincuenta años de la
                                “Rapsodia peruana” de Claudio Rebagliati.<br></span>
                            <span class="text-gris">
                                En: Infoartes.pe</span><br>
                            <a href="http://www.infoartes.pe/un-28-de-julio-ciento-cincuenta-anos-de-la-rapsodia-peruana-de-claudio-rebagliati-entrevista-a-miguel-oblitas-y-augusto-rebagliati/"
                                target="_blank" style="color: black;">
                                <span class="fas fa-share-square text-gris"></span>
                            </a>
                        </p>
                        <p class="font-24">
                            <span class="fontMS500">Raygada, C. (1954).</span><br>
                            <span class="fontMS100Italic text-gris">Historia crítica del himno nacional.<br></span>
                            <span class="text-gris">
                                Lima: Juan Mejía Baca & P.L. Villanueva Editores.<br>
                            </span>
                            <a href="http://info.bnp.gob.pe:80/cgi-bin/abnopac?TITN=281492" target="_blank"
                                style="color: black;">
                                <span class="fas fa-share-square text-gris"></span>
                            </a>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- Footer -->